module.exports = __webpack_public_path__ + "static/media/notice_bg_1.80a79019.png";